import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { shopApi } from "./shopApi";

export const useContactFormSubmissions = (skip: number = 0, take: number = 50, enabled: boolean = true) => {
  const queryClient = useQueryClient();

  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.CONTACT_FORM_SUBMISSIONS(),
    queryFn: () => shopApi.fetchContactFormSubmissions(skip, take),
    enabled,
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.CONTACT_FORM_SUBMISSIONS(),
    });
  };

  return {
    isLoading,
    isFetching,
    submissions: data?.data?.items ?? [],
    total: data?.data?.total ?? 0,
    invalidate,
  };
};
